namespace TabAurous.ECommerce {
    export interface ECommOrderLaborRow {
        TransLbrId?: number;
        TransItemId?: number;
        ItemTypeId?: number;
        AttributeId?: number;
        ProcessId?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        CalcOnId?: number;
        CalcOn?: string;
        LabourRate?: number;
        MarkUp?: number;
        LabourAmount?: number;
        CCLabourAmount?: number;
        DiscountPercent?: number;
        Discount?: number;
        ProductTypeId?: number;
        ProductTypeName?: string;
        CategoryId?: number;
        CategoryName?: string;
        SubCategoryId?: number;
        SubCategoryName?: string;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        StoneColorId?: number;
        ShapeId?: number;
        SieveId?: number;
        QualityId?: number;
        StoneSizeId?: number;
        ProcessName?: string;
        Attribute?: string;
        IsCustomerItem?: boolean;
        CalculateTo?: number;
    }

    export namespace ECommOrderLaborRow {
        export const idProperty = 'TransLbrId';
        export const nameProperty = 'ProcessName';
        export const localTextPrefix = 'ECommerce.ECommOrderLabor';
        export const deletePermission = 'EComm:ECommOrder:Delete';
        export const insertPermission = 'EComm:ECommOrder:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommOrder:Edit';

        export declare const enum Fields {
            TransLbrId = "TransLbrId",
            TransItemId = "TransItemId",
            ItemTypeId = "ItemTypeId",
            AttributeId = "AttributeId",
            ProcessId = "ProcessId",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            CalcOnId = "CalcOnId",
            CalcOn = "CalcOn",
            LabourRate = "LabourRate",
            MarkUp = "MarkUp",
            LabourAmount = "LabourAmount",
            CCLabourAmount = "CCLabourAmount",
            DiscountPercent = "DiscountPercent",
            Discount = "Discount",
            ProductTypeId = "ProductTypeId",
            ProductTypeName = "ProductTypeName",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            SubCategoryId = "SubCategoryId",
            SubCategoryName = "SubCategoryName",
            BrandId = "BrandId",
            CollectionId = "CollectionId",
            SuperTypeId = "SuperTypeId",
            StoneColorId = "StoneColorId",
            ShapeId = "ShapeId",
            SieveId = "SieveId",
            QualityId = "QualityId",
            StoneSizeId = "StoneSizeId",
            ProcessName = "ProcessName",
            Attribute = "Attribute",
            IsCustomerItem = "IsCustomerItem",
            CalculateTo = "CalculateTo"
        }
    }
}
